// --------------------------------------------------
// Multi Inventory
// E-shop availability + expedition + boutique drawer
// --------------------------------------------------

(function () {
  let inventoryObserver = null;
  let appWaitObserver = null;

  let customDisplay = null;
  let overlay = null;
  let drawer = null;

  let embroideryBlock = null;
  let embroideryParent = null;
  let embroideryNextSibling = null;

  let quantityWrapper = null;
  let quantityParent = null;
  let quantityNextSibling = null;

  const lang = document.documentElement.lang?.toLowerCase().startsWith('en')
    ? 'en'
    : 'fr';

  const translations = {
    fr: {
      inStock: 'En stock',
      outOfStock: 'Épuisé',
      unavailableDelivery: "Ce produit n'est pas disponible à la livraison",
      createAlert: 'Créer une alerte',
      storeAvailability: 'Voir la disponibilité en boutique',
      storeAvailabilityTitle: 'Disponibilité en boutique',
      close: 'Fermer'
    },
    en: {
      inStock: 'In stock',
      outOfStock: 'Out of stock',
      unavailableDelivery: 'This product is not available for delivery',
      createAlert: 'Create an alert',
      storeAvailability: 'Check in-store availability',
      storeAvailabilityTitle: 'In-store availability',
      close: 'Close'
    }
  };

  const t = translations[lang];

  // --------------------------------------------------
  // Styles
  // --------------------------------------------------

  function injectInventoryStyles() {
    if (document.querySelector('#custom-inventory-styles')) {
      return;
    }

    const style = document.createElement('style');

    style.id = 'custom-inventory-styles';

    style.textContent = `

      [data-a11y-identifier^="bis-button-"] {
  display: none !important;
}

[data-custom-klaviyo-bis] {
  display: flex;
  width: 100%;
  justify-content: center;
}

[data-custom-klaviyo-bis][hidden] {
  display: none !important;
}

      /* -----------------------------------------------
         Product inventory
      ------------------------------------------------ */

      .custom-inventory-display {
        margin-top: 0.8rem;
        text-align: center;
      }

      .custom-inventory-eshop {
        margin-bottom: 0.8rem;
      }


      /* -----------------------------------------------
         E-shop status
      ------------------------------------------------ */

      .custom-inventory-eshop {
  display: flex;
  align-items: baseline;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;

  margin-bottom: 10px;

  font-family: 'Newsreader', serif;
  font-size: 0.8rem;
  line-height: 1.4;
  letter-spacing: 0.01rem;
}

.custom-inventory-status {
  display: inline;

  font-family: 'Newsreader', serif;
  line-height: inherit;
  letter-spacing: inherit;
}

.custom-inventory-status--oos {
  color: #d0021b;
}

.custom-inventory-status--available {
  color: #649231;
}


/* -----------------------------------------------
   Expedition
------------------------------------------------ */

.custom-inventory-expedition {
  display: inline;
  margin: 0;
}

.custom-inventory-expedition:empty {
  display: none;
}

.custom-inventory-expedition .expedition-date {
  display: inline;

  font-family: 'Newsreader', serif;

  margin: 0 !important;
}

.custom-inventory-expedition .expedition-date:not([hidden])::before {
  content: " · ";
  white-space: pre;
}

.custom-inventory-expedition .expedition-date[hidden] {
  display: none !important;
}


      /* -----------------------------------------------
         Boutique trigger
      ------------------------------------------------ */

      .custom-inventory-boutique-trigger {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        font-family: 'Newsreader', serif !important;

        margin: 0;
        padding: 0;

        border: 0;
        background: none;

        color: inherit;

        font: inherit;
        font-size: 0.9rem;
        letter-spacing: 0.02rem;

        cursor: pointer;
      }

      .custom-inventory-boutique-trigger span {
        padding: 1px 0 0;
        text-decoration: underline;
        text-underline-offset: 3px;
      }

      .custom-inventory-boutique-trigger[hidden] {
        display: none !important;
      }


      /* -----------------------------------------------
         Overlay
      ------------------------------------------------ */

      .custom-inventory-overlay {
        position: fixed;
        inset: 0;

        z-index: 9998;

        background: rgba(0, 0, 0, 0.25);

        opacity: 0;

        transition: opacity 0.3s ease;
      }

      .custom-inventory-overlay.is-visible {
        opacity: 1;
      }

      .custom-inventory-overlay[hidden] {
        display: none !important;
      }


      /* -----------------------------------------------
         Drawer
      ------------------------------------------------ */

      .custom-inventory-drawer {
        position: fixed;

        top: 0;
        right: 0;
        bottom: 0;

        z-index: 9999;

        width: min(420px, 90vw);

        background: #fff;

        transform: translateX(100%);

        transition: transform 0.3s ease;

        overflow-y: auto;
      }

      .custom-inventory-drawer.is-open {
        transform: translateX(0);
      }


      /* -----------------------------------------------
         Drawer header
      ------------------------------------------------ */

      .custom-inventory-drawer__header {
        display: flex;
        align-items: center;
        justify-content: space-between;

        padding: 0.8rem 0.4rem 0.8rem 1.4rem;

        border-bottom: 1px solid rgba(0, 0, 0, 0.12);
      }

      .custom-inventory-drawer__header h2 {
        margin: 0;

        font-size: 0.95rem;
        font-weight: 700;
        letter-spacing: 0.09rem !important;
        line-height: 1.3;
      }

      .custom-inventory-drawer__close {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 36px;
        height: 36px;

        margin: 0;
        padding: 0;

        border: 0;
        background: none;

        color: inherit;

        font-size: 28px;
        font-weight: 300;
        line-height: 1;

        cursor: pointer;
      }


      /* -----------------------------------------------
         Drawer content
      ------------------------------------------------ */

      .custom-inventory-drawer__content {
        padding: 28px 24px;
      }

      .custom-inventory-boutique__product {
        margin: 1.5rem 0 0.5rem;
        font-size: 0.8rem;
        font-weight: 700;
        line-height: 1.4;
        text-transform: uppercase;
        letter-spacing: 0.08em;
}


      /* -----------------------------------------------
         Boutique variant
      ------------------------------------------------ */

      .custom-inventory-boutique__variant-row {
        border-bottom: 1px solid #eee;
        line-height: 2;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  font-size: 0.7rem;
  gap: 1rem;
    margin: 0.2rem 0 0;
}

  .custom-inventory-boutique__variant {
    font-size: 0.65rem;
    letter-spacing: 0.08em;
    margin-bottom: 0;
    text-transform: uppercase;
  }


      /* -----------------------------------------------
         Boutique stock
      ------------------------------------------------ */

      .custom-inventory-boutique__stock {
        margin: 0;
  white-space: nowrap;

        font-weight: 600;
        line-height: 1.3;

        letter-spacing: 0.02em;
      }

      .custom-inventory-boutique__stock--available {
        color: #649231;
      }

      .custom-inventory-boutique__stock--oos {
        color: #d0021b;
      }


      /* -----------------------------------------------
         Boutique location
      ------------------------------------------------ */

      .custom-inventory-boutique__location {
        font-family: "Newsreader", serif;
        margin-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.4;
    font-weight: 300;
    letter-spacing: 0.02rem;
        
      }

      .custom-inventory-boutique__note {
        font-family: "Newsreader", serif;
        font-size: 0.85rem;
        line-height: 1.5;
        font-weight: 300;
    letter-spacing: 0.02rem;

      }


      /* -----------------------------------------------
         Prevent background scroll
      ------------------------------------------------ */

      body.custom-inventory-drawer-open {
        overflow: hidden;
      }

    `;

    document.head.appendChild(style);
  }


  // --------------------------------------------------
  // Get Multi Inventory locations
  // --------------------------------------------------

  function getInventoryLocations(inventoryApp) {
  const items = Array.from(
    inventoryApp.querySelectorAll('.iia-list-item')
  );

  const getLocationName = (item) => {
    const location = item.querySelector('.iia-location');

    if (location) {
      return location.textContent
        .trim()
        .toLowerCase();
    }

    const name = item.querySelector('.iia-name');

    if (name) {
      return name.textContent
        .trim()
        .toLowerCase();
    }

    return '';
  };

  const eshopItem = items.find((item) => {
    return getLocationName(item) === 'e-shop';
  });

  const boutiqueItem = items.find((item) => {
    const locationName = getLocationName(item);

    return (
      locationName !== '' &&
      locationName !== 'e-shop'
    );
  });

  return {
    eshopItem,
    boutiqueItem
  };
}



  // --------------------------------------------------
  // Determine whether a location is out of stock
  // --------------------------------------------------

  function isOutOfStock(item) {
  if (!item) {
    return false;
  }

  /*
   * Some products expose several inventory rows inside
   * the same location, e.g.:
   *
   * 50x70 → En stock
   * 65x65 → Épuisé
   *
   * If one checked product radio EXACTLY matches one of
   * those inventory row names, use that specific row.
   *
   * Otherwise preserve the existing behaviour.
   */
  const rows = Array.from(
    item.querySelectorAll('.iia-grouped-item')
  );

  let stock = null;

  if (rows.length > 1) {
    const checkedValues = Array.from(
      document.querySelectorAll('input[type="radio"]:checked')
    )
      .map((input) => input.value?.trim())
      .filter(Boolean);

    const matchingRow = rows.find((row) => {
      const name = row.querySelector('.iia-name');

      if (!name) {
        return false;
      }

      const rowName = name.textContent.trim();

      return checkedValues.some(value =>
        rowName === value || rowName.endsWith(' / ' + value)
      );
    });

    if (matchingRow) {
      stock = matchingRow.querySelector(
        '.iia-stock-threshold'
      );
    }
  }

  /*
   * Original behaviour.
   *
   * This remains the fallback for all products where
   * no exact selected-radio/inventory-row match exists.
   */
  if (!stock) {
    stock = item.querySelector(
      '.iia-stock-threshold'
    );
  }

  if (!stock) {
    return false;
  }

  const text = stock.textContent
    .trim()
    .toLowerCase();

  return (
    text.includes('épuis') ||
    text.includes('rupture') ||
    text.includes('out of stock')
  );
}


  // --------------------------------------------------
  // Move expedition underneath E-shop status
  // --------------------------------------------------

  function moveExpeditionIntoInventory() {
    if (!customDisplay) {
      return;
    }

    const expeditionDate = document.querySelector(
      '[data-expedition-date]'
    );

    const expeditionContainer = customDisplay.querySelector(
      '[data-custom-inventory-expedition]'
    );

    if (!expeditionDate || !expeditionContainer) {
      return;
    }

    /*
     * Only move it if it isn't already in our container.
     */
    if (
      expeditionDate.parentElement !==
      expeditionContainer
    ) {
      expeditionContainer.appendChild(
        expeditionDate
      );
    }
  }


  // --------------------------------------------------
  // Expedition visibility
  // --------------------------------------------------

  function updateExpeditionVisibility(eshopOutOfStock) {
    /*
     * The Liquid block might have been rendered/re-rendered
     * since initialisation, so try moving it again first.
     */
    moveExpeditionIntoInventory();

    document
      .querySelectorAll('[data-expedition-date]')
      .forEach((expeditionDate) => {
        expeditionDate.hidden = eshopOutOfStock;
      });
  }


  function updateAddToCartForEshop(eshopOutOfStock) {

    const addToCartButton = document.querySelector(
      '[data-testid="standalone-add-to-cart"]'
    );

    const addToCartWrapper =
      addToCartButton?.closest('add-to-cart-component')?.parentElement;

    const klaviyoBisButton = document.querySelector(
      '[data-custom-klaviyo-bis]'
    );

    if (!embroideryBlock) {
  embroideryBlock = document.querySelector(
    '[data-embroidery-block]'
  );

  if (embroideryBlock) {
    embroideryParent = embroideryBlock.parentElement;
    embroideryNextSibling = embroideryBlock.nextSibling;
  }
}

if (!quantityWrapper) {
  quantityWrapper = document.querySelector(
    '[ref="quantitySelectorWrapper"]'
  );

  if (quantityWrapper) {
    quantityParent = quantityWrapper.parentElement;
    quantityNextSibling = quantityWrapper.nextSibling;
  }
}

    if (!addToCartButton || !klaviyoBisButton) {
      return;
    }

  if (eshopOutOfStock) {
    /*
     * Copy the real Add to Cart button styling.
     */
    klaviyoBisButton.className = addToCartButton.className;

    /*
     * Put our alert AFTER the whole Shopify
     * Add to Cart component, not inside it.
     */
    const addToCartComponent = addToCartButton.closest(
      'add-to-cart-component'
    );

    if (addToCartWrapper) {
  addToCartWrapper.insertAdjacentElement(
    'afterend',
    klaviyoBisButton
  );
}
    if (embroideryBlock) {
      embroideryBlock.remove();
    }

    if (quantityWrapper) {
      quantityWrapper.remove();
    }

    addToCartWrapper.hidden = true;
    addToCartButton.hidden = true;

    klaviyoBisButton.hidden = false;

  } else {

    if (
      embroideryBlock &&
      embroideryParent &&
      !embroideryBlock.isConnected
    ) {
      if (
        embroideryNextSibling &&
        embroideryNextSibling.parentNode === embroideryParent
      ) {
        embroideryParent.insertBefore(
          embroideryBlock,
          embroideryNextSibling
        );
      } else {
        embroideryParent.appendChild(
          embroideryBlock
        );
      }
    }

    if (
      quantityWrapper &&
      quantityParent &&
      !quantityWrapper.isConnected
    ) {
      if (
        quantityNextSibling &&
        quantityNextSibling.parentNode === quantityParent
      ) {
        quantityParent.insertBefore(
          quantityWrapper,
          quantityNextSibling
        );
      } else {
        quantityParent.appendChild(
          quantityWrapper
        );
      }
    }

    addToCartWrapper.hidden = false;
    addToCartButton.hidden = false;
    klaviyoBisButton.hidden = true;
  }
}


  // --------------------------------------------------
  // Update custom inventory display
  // --------------------------------------------------

  function updateInventoryDisplay(inventoryApp) {
    if (
      !inventoryApp ||
      !customDisplay ||
      !drawer
    ) {
      return;
    }


    /*
     * Make sure expedition remains in the correct place.
     */
    moveExpeditionIntoInventory();


    const {
      eshopItem,
      boutiqueItem
    } = getInventoryLocations(inventoryApp);


    // --------------------------------------------------
    // E-shop
    // --------------------------------------------------

    const eshopDisplay = customDisplay.querySelector(
      '[data-custom-inventory-eshop]'
    );

    if (eshopItem) {

const debugNames = Array.from(
  eshopItem.querySelectorAll('.iia-name')
);

const debugStocks = Array.from(
  eshopItem.querySelectorAll('.iia-stock-threshold')
);




      const eshopOOS = isOutOfStock(
        eshopItem
      );

      document.querySelectorAll('.end-of-collection-message').forEach(
  message => message.hidden = eshopOOS
);


      if (eshopOOS) {
        eshopDisplay.innerHTML = `
          <span
            class="
              custom-inventory-status
              custom-inventory-status--oos
            "
          >
            ${t.outOfStock}
          </span>
          <span>- ${t.unavailableDelivery}</span>
        `;
      } else {
        eshopDisplay.innerHTML = `
          <span
            class="
              custom-inventory-status
              custom-inventory-status--available
            "
          >
            ${t.inStock}
          </span>
        `;
      }


      /*
       * Expedition only exists visually when
       * E-shop inventory is available.
       */
      updateExpeditionVisibility(
        eshopOOS
      );

      updateAddToCartForEshop(eshopOOS);



    } else {
      /*
       * Multi Inventory hasn't rendered the E-shop
       * status yet.
       *
       * Don't guess.
       */

      document.querySelectorAll('.end-of-collection-message').forEach(
  message => message.hidden = true
);

      eshopDisplay.innerHTML = '';

      updateExpeditionVisibility(
        false
      );

updateAddToCartForEshop(false);

    }


    // --------------------------------------------------
    // Boutique
    // --------------------------------------------------

    const boutiqueContent = drawer.querySelector(
      '[data-custom-inventory-boutique]'
    );

    const boutiqueTrigger = customDisplay.querySelector(
      '[data-custom-inventory-open]'
    );


    if (boutiqueItem) {
      const location = boutiqueItem.querySelector(
  '.iia-location'
);

const note = boutiqueItem.querySelector(
  '.iia-note'
);

const name = boutiqueItem.querySelector(
  '.iia-name'
);

const stock = boutiqueItem.querySelector(
  '.iia-stock-threshold'
);

/*
 * With variants:
 *   .iia-location = boutique
 *   .iia-name     = variant
 *
 * Without a real variant:
 *   .iia-location = absent
 *   .iia-name     = boutique
 */

const productTitle = document
  .querySelector('.product-title-name')
  ?.textContent
  .trim();

const variant = location ? name : null;
const boutiqueLocation = location || name;

      const boutiqueOOS = isOutOfStock(
        boutiqueItem
      );


      boutiqueContent.innerHTML = `

        ${
  boutiqueLocation
    ? `
      <div
        class="custom-inventory-boutique__location"
      >
        ${boutiqueLocation.textContent
          .trim()
          .split(' - ')
          .map(part => `<div>${part.trim()}</div>`)
          .join('')}
      </div>
    `
    : ''
}

        ${
          note
            ? `
              <div
                class="custom-inventory-boutique__note"
              >
                ${note.textContent.trim()}
              </div>
            `
            : ''
        }

        ${
  productTitle
    ? `
      <div class="custom-inventory-boutique__product">
        ${productTitle}
      </div>
    `
    : ''
}

        ${
  variant
    ? `
      <div class="custom-inventory-boutique__variant-row">

        <div class="custom-inventory-boutique__variant">
          ${variant.textContent.trim()}
        </div>

        ${
          stock
            ? `
              <div
                class="
                  custom-inventory-boutique__stock
                  ${
                    boutiqueOOS
                      ? 'custom-inventory-boutique__stock--oos'
                      : 'custom-inventory-boutique__stock--available'
                  }
                "
              >
                ${boutiqueOOS ? t.outOfStock : t.inStock}
              </div>
            `
            : ''
        }

      </div>
    `
    : stock
      ? `
        <div class="custom-inventory-boutique__variant-row">

          <div></div>

          <div
            class="
              custom-inventory-boutique__stock
              ${
                boutiqueOOS
                  ? 'custom-inventory-boutique__stock--oos'
                  : 'custom-inventory-boutique__stock--available'
              }
            "
          >
            ${boutiqueOOS ? t.outOfStock : t.inStock}
          </div>

        </div>
      `
      : ''
}

        

        

      `;


      boutiqueTrigger.hidden = false;

    } else {
      boutiqueContent.innerHTML = '';

      boutiqueTrigger.hidden = true;
    }


    // --------------------------------------------------
    // Hide original Multi Inventory output
    // --------------------------------------------------

    inventoryApp.style.display = 'none';
  }


  // --------------------------------------------------
  // Create custom inventory UI
  // --------------------------------------------------

  function createCustomInventoryUI(inventoryApp) {
    const existingDisplay = document.querySelector(
      '.custom-inventory-display'
    );

    if (existingDisplay) {
      customDisplay = existingDisplay;

      drawer = document.querySelector(
        '.custom-inventory-drawer'
      );

      overlay = document.querySelector(
        '.custom-inventory-overlay'
      );

      moveExpeditionIntoInventory();

      return;
    }


    // --------------------------------------------------
    // Product page display
    // --------------------------------------------------

    customDisplay = document.createElement(
      'div'
    );

    customDisplay.className =
      'custom-inventory-display';


    customDisplay.innerHTML = `

      <div class="custom-inventory-eshop">

        <div
          data-custom-inventory-eshop
        ></div>

        <div
          class="custom-inventory-expedition"
          data-custom-inventory-expedition
        ></div>

      </div>

      <a
  href="#"
  class="klaviyo-bis-trigger custom-klaviyo-bis-button"
  data-custom-klaviyo-bis
  hidden
>
  ${t.createAlert}
</a>

      <button
        type="button"
        class="custom-inventory-boutique-trigger"
        data-custom-inventory-open
      >
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="feather feather-map-pin"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
        
      <span>
          ${t.storeAvailability}
        </span>
      </button>

    `;

    const klaviyoBisTrigger = customDisplay.querySelector(
  '[data-custom-klaviyo-bis]'
);

if (klaviyoBisTrigger) {
  klaviyoBisTrigger.addEventListener('click', (event) => {
    event.preventDefault();

    if (window.klaviyo) {
      window.klaviyo.openForm('ReRxHF');
    }
  });
}


    /*
     * Place our custom block exactly where
     * Multi Inventory was rendered.
     */
    inventoryApp.insertAdjacentElement(
      'afterend',
      customDisplay
    );


    /*
     * Move existing expedition Liquid block
     * directly underneath E-shop status.
     */
    moveExpeditionIntoInventory();


    // --------------------------------------------------
    // Overlay
    // --------------------------------------------------

    overlay = document.createElement(
      'div'
    );

    overlay.className =
      'custom-inventory-overlay';

    overlay.hidden = true;

    document.body.appendChild(
      overlay
    );


    // --------------------------------------------------
    // Drawer
    // --------------------------------------------------

    drawer = document.createElement(
      'aside'
    );

    drawer.className =
      'custom-inventory-drawer';

    drawer.setAttribute(
      'aria-hidden',
      'true'
    );


    drawer.innerHTML = `

      <div
        class="custom-inventory-drawer__header"
      >

        <h2>
          ${t.storeAvailabilityTitle}
        </h2>

        <button
          type="button"
          class="custom-inventory-drawer__close"
          aria-label="${t.close}"
        >
          ×
        </button>

      </div>

      <div
        class="custom-inventory-drawer__content"
        data-custom-inventory-boutique
      ></div>

    `;


    document.body.appendChild(
      drawer
    );


    // --------------------------------------------------
    // Open / close
    // --------------------------------------------------

    const openButton = customDisplay.querySelector(
      '[data-custom-inventory-open]'
    );

    const closeButton = drawer.querySelector(
      '.custom-inventory-drawer__close'
    );


    function openDrawer() {
      updateInventoryDisplay(
        inventoryApp
      );

      overlay.hidden = false;


      requestAnimationFrame(() => {
        overlay.classList.add(
          'is-visible'
        );

        drawer.classList.add(
          'is-open'
        );
      });


      drawer.setAttribute(
        'aria-hidden',
        'false'
      );


      document.body.classList.add(
        'custom-inventory-drawer-open'
      );
    }


    function closeDrawer() {
      overlay.classList.remove(
        'is-visible'
      );

      drawer.classList.remove(
        'is-open'
      );


      drawer.setAttribute(
        'aria-hidden',
        'true'
      );


      document.body.classList.remove(
        'custom-inventory-drawer-open'
      );


      window.setTimeout(() => {
        if (
          !overlay.classList.contains(
            'is-visible'
          )
        ) {
          overlay.hidden = true;
        }
      }, 300);
    }


    openButton.addEventListener(
      'click',
      openDrawer
    );


    closeButton.addEventListener(
      'click',
      closeDrawer
    );


    overlay.addEventListener(
      'click',
      closeDrawer
    );


    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Escape' &&
          drawer.classList.contains(
            'is-open'
          )
        ) {
          closeDrawer();
        }
      }
    );
  }


  // --------------------------------------------------
  // Initialise Multi Inventory app
  // --------------------------------------------------

  function initialiseInventoryApp(
    inventoryApp
  ) {
    if (
      inventoryApp.dataset
        .customInventoryInitialised ===
      'true'
    ) {
      updateInventoryDisplay(
        inventoryApp
      );

      return;
    }


    inventoryApp.dataset
      .customInventoryInitialised =
      'true';


    // --------------------------------------------------
    // Create UI
    // --------------------------------------------------

    createCustomInventoryUI(
      inventoryApp
    );


    // --------------------------------------------------
    // Initial render
    // --------------------------------------------------

    updateInventoryDisplay(
      inventoryApp
    );


    // --------------------------------------------------
    // Watch Multi Inventory for variant changes
    // --------------------------------------------------

    if (inventoryObserver) {
      inventoryObserver.disconnect();
    }


    inventoryObserver =
      new MutationObserver(() => {
        updateInventoryDisplay(
          inventoryApp
        );
      });


    inventoryObserver.observe(
      inventoryApp,
      {
        childList: true,
        subtree: true,
        characterData: true
      }
    );

document.addEventListener('change', (event) => {
  if (
    event.target.matches(
      'input[type="radio"]'
    )
  ) {
    /*
     * Let Shopify and Multi Inventory finish
     * reacting to the variant change first.
     */
    window.setTimeout(() => {
      updateInventoryDisplay(
        inventoryApp
      );
    }, 100);
  }
});

  }


  // --------------------------------------------------
  // Find Multi Inventory
  // --------------------------------------------------

  function findInventoryApp() {
    const inventoryApp =
      document.querySelector(
        '#inventory-info-app'
      );


    if (!inventoryApp) {
      return false;
    }


    initialiseInventoryApp(
      inventoryApp
    );

    return true;
  }


  // --------------------------------------------------
  // Initialise
  // --------------------------------------------------

  function initCustomInventory() {
    injectInventoryStyles();


    /*
     * Multi Inventory may already
     * have rendered.
     */
    if (findInventoryApp()) {
      return;
    }


    /*
     * Otherwise wait for Multi Inventory.
     */
    appWaitObserver =
      new MutationObserver(() => {
        if (findInventoryApp()) {
          appWaitObserver.disconnect();

          appWaitObserver = null;
        }
      });


    appWaitObserver.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  // --------------------------------------------------
  // Start
  // --------------------------------------------------

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      initCustomInventory
    );
  } else {
    initCustomInventory();
  }

})();